import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { toPickerHex } from '../../lib/color';

export default function ColorField({
  label, name, value, fallback = '#000000', onChange,
}) {
  const hex = toPickerHex(value, fallback);
  const emit = (next) => onChange({ target: { name, value: next } });

  return (
    <TextField
      size="small"
      label={label}
      name={name}
      value={value || ''}
      onChange={onChange}
      placeholder={fallback}
      sx={{ flex: 1, minWidth: 140 }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start" sx={{ mr: 1 }}>
            <input
              type="color"
              aria-label={label}
              value={hex}
              onChange={(event) => emit(event.target.value)}
              style={{
                width: 28,
                height: 28,
                padding: 0,
                border: '1px solid #bbb',
                borderRadius: 4,
                background: 'none',
                cursor: 'pointer',
              }}
            />
          </InputAdornment>
        ),
      }}
    />
  );
}
